<template>
  <div class="etms-router-body">
    <el-tabs v-model="inboundactive" @tab-click="handleClick">
      <el-tab-pane label="单包裹入库" name="single">
        <div class="contant-outer-left fl">
          <el-form label-width="100px" class="etms-router-form">
            <el-form-item label="袋号：">
              <el-input size="mini" placeholder="请输入袋号" class="el-width-200" disabled></el-input>
            </el-form-item>
            <el-form-item label="批次号：">
              <el-input size="mini" placeholder="请输入批次号" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="重量：">
              <el-input type="number" size="mini" placeholder="请输入重量KG(必填)" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="体积：">
              <el-input type="number" size="mini" placeholder="长(cm)" class="el-width-100"></el-input><br />
              <el-input type="number" size="mini" placeholder="宽(cm)" class="el-width-100"></el-input><br />
              <el-input type="number" size="mini" placeholder="高(cm)" class="el-width-100"></el-input>
            </el-form-item>
            <el-form-item label="预警重量：">
              <el-input type="number" size="mini" placeholder="kg" class="el-width-100"></el-input>
            </el-form-item>
            <el-form-item label="单号：">
              <el-input size="mini" placeholder="请扫描单号" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="是否核算：">
              <el-checkbox>核算</el-checkbox>
            </el-form-item>
          </el-form>
        </div>
        <div class="contant-outer-right fl">
          <el-table :data="inboundlist" class="etms-router-list">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="客户" prop="CustomerName"></el-table-column>
            <el-table-column label="渠道" prop="ChannelName"></el-table-column>
            <el-table-column label="线路">
              <template slot-scope="scope">
                {{scope.row.LineName}}-{{scope.row.ShipmentRegionName}}-{{scope.row.PurposeRegionName}}
              </template>
            </el-table-column>
            <el-table-column label="单号" prop="Odd"></el-table-column>
            <el-table-column label="批次号" prop="InboundBatch"></el-table-column>
            <el-table-column label="袋号" prop="BagCode"></el-table-column>
            <el-table-column label="确认重" prop="ConfirmTotalWeight"></el-table-column>
            <el-table-column label="确认体积">
              <template slot-scope="scope">
                {{scope.row.ConfirmLong}}*{{scope.row.ConfirmWide}}*{{scope.row.ConfirmHigh}}
              </template>
            </el-table-column>
            <el-table-column label="入库重" prop="PutStorageTotalWeight"></el-table-column>
            <el-table-column label="入库体积">
              <template slot-scope="scope">
                {{scope.row.PutStorageLong}}*{{scope.row.PutStorageWide}}*{{scope.row.PutStorageHigh}}
              </template>
            </el-table-column>
            <el-table-column label="总费用" prop="TotalFee"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>费用类型</th>
                    <th>标准价</th>
                    <th>折扣价</th>
                    <th>计费值</th>
                    <th>计费公示</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                    <td>{{item.WaybillFeeType}}</td>
                    <td>{{item.StandardFee}}</td>
                    <td>{{item.DiscountFee}}</td>
                    <td>{{item.BillingValue}}</td>
                    <td>{{item.BillingFormulaString}}</td>
                    <td>{{item.BillingFormulaNote}}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="多包裹入库" name="multiple">
        <div style="padding-bottom:5px;">
          <el-input size="mini" placeholder="请输入批次号" class="el-width-200" v-model="multipleform.batch"></el-input>
          <el-input size="mini" placeholder="请扫描单号" class="el-width-200" v-model="multipleform.odd" @keyup.enter.native="submitMultiple"></el-input>
        </div>
        <div style="padding:5px 0;" v-show="multipleform.isshow">
          <span>单号：</span><span>{{multipleform.odd}}</span>
          <span>入库批次：</span><span>{{multipleform.batch}}</span>
          <span>客户：</span><span>{{multipleform.CustomerName}}</span>
          <span>渠道：</span><span>{{multipleform.ChannelName}}</span>
          <span>线路：</span><span>{{multipleform.LineName}}-{{multipleform.ShipmentRegionName}}-{{multipleform.PurposeRegionName}}</span>
          <span>数量：</span><span>{{multipleform.ConfirmQuantity}}</span>
        </div>

        <el-table :data="multipleform.parcellist" :border="true" v-show="multipleform.isshow" class="etms-router-list">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="箱号" prop="CaseNumber"></el-table-column>
          <el-table-column label="子单号" prop="ParcleOdd"></el-table-column>
          <el-table-column label="客户重量" prop="ParcelConfirmWeight" width="70px" align="center"> </el-table-column>
          <el-table-column label="确认长" prop="ParcelConfirmLong" width="70px" align="center"> </el-table-column>
          <el-table-column label="确认宽" prop="ParcelConfirmWide" width="70px" align="center"> </el-table-column>
          <el-table-column label="确认高" prop="ParcelConfirmHigh" width="70px" align="center"> </el-table-column>
          <el-table-column label="确认体积重" prop="ParcelConfirmVolumeWeight" width="90px" align="center"> </el-table-column>
          <el-table-column label="入库重量" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelPutStorageWeight"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="入库长" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelPutStorageLong"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="入库宽" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelPutStorageWide"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="入库高" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelPutStorageHigh"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="入库体积重" align="center" prop="ParcelPutStorageVolumeWeight"></el-table-column>
          <el-table-column align="center" width="70px">
            <template slot="header" slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="添加更多包裹" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertMultiple()"></el-button>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除此包裹" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteMultiple(spoce.$index,spoce.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding:10px;" v-show="multipleform.isshow">
          <el-button size="mini" type="primary" class="fr" @click="submitMultipleInbound">确认入库</el-button>
        </div>
        <div class="clear"></div>
        <div style="padding-top: 10px;" class="etms-router-list">
          <el-table :data="multiplelist" :border="true">
            <el-table-column label="序号" type="index" width="50px" align="center"></el-table-column>
            <el-table-column label="单号" prop="Odd"></el-table-column>
            <el-table-column label="客户" prop="CustomerName"></el-table-column>
            <el-table-column label="渠道" prop="ChannelName"></el-table-column>
            <el-table-column label="线路">
              <template slot-scope="scope">
                {{scope.row.LineName}}-{{scope.row.ShipmentRegionName}}-{{scope.row.PurposeRegionName}}
              </template>
            </el-table-column>
            <el-table-column label="批次" prop="InboundBatch"></el-table-column>
            <el-table-column label="客户重量" prop="ConfirmTotalWeight"></el-table-column>
            <el-table-column label="确认体积" prop="ConfirmTotalVolume"></el-table-column>
            <el-table-column label="确认体积重" prop="ConfirmTotalVolumeWeight"></el-table-column>
            <el-table-column label="入库重量" prop="PutStorageTotalWeight"></el-table-column>
            <el-table-column label="入库体积" prop="PutStorageTotalVolume"></el-table-column>
            <el-table-column label="入库体积重" prop="PutStorageTotalVolumeWeight"></el-table-column>
            <el-table-column label="总费用" prop="TotalFee"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>费用类型</th>
                    <th>标准价</th>
                    <th>折扣价</th>
                    <th>计费值</th>
                    <th>计费公示</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                    <td>{{item.WaybillFeeType}}</td>
                    <td>{{item.StandardFee}}</td>
                    <td>{{item.DiscountFee}}</td>
                    <td>{{item.BillingValue}}</td>
                    <td>{{item.BillingFormulaString}}</td>
                    <td>{{item.BillingFormulaNote}}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="集装箱入库" name="container">
        <div class="contant-outer-left fl">
          <el-form label-width="100px" class="etms-router-form">
            <el-form-item label="批次：">
              <el-input size="mini" placeholder="请输入批次号" class="el-width-150" v-model="containerform.batch"></el-input>
            </el-form-item>
            <el-form-item label="重量：">
              <el-input size="mini" type="number" placeholder="请录入重量" class="el-width-150" v-model="containerform.weight"></el-input>
            </el-form-item>
            <el-form-item label="数量：">
              <el-input-number size="mini" class="el-width-100" v-model="containerform.quantity"></el-input-number>
            </el-form-item>
            <el-form-item label="单号：">
              <el-input size="mini" placeholder="请扫描单号" class="el-width-150" v-model="containerform.odd" @keyup.enter.native="submitContainer"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="contant-outer-right fl">
          <el-table :data="inboundlist" class="etms-router-list">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="客户" prop="CustomerName"></el-table-column>
            <el-table-column label="渠道" prop="ChannelName"></el-table-column>
            <el-table-column label="线路">
              <template slot-scope="scope">
                {{scope.row.LineName}}-{{scope.row.ShipmentRegionName}}-{{scope.row.PurposeRegionName}}
              </template>
            </el-table-column>
            <el-table-column label="单号" prop="Odd"></el-table-column>
            <el-table-column label="批次号" prop="InboundBatch"></el-table-column>
            <el-table-column label="确认重" prop="ConfirmTotalWeight"></el-table-column>
            <el-table-column label="确认数量" prop="ConfirmQuantity"></el-table-column>
            <el-table-column label="入库重" prop="PutStorageTotalWeight"></el-table-column>
            <el-table-column label="入库数量" prop="PutStorageQuantity"></el-table-column>
            <el-table-column label="总费用" prop="TotalFee"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>费用类型</th>
                    <th>标准价</th>
                    <th>折扣价</th>
                    <th>计费值</th>
                    <th>计费公示</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                    <td>{{item.WaybillFeeType}}</td>
                    <td>{{item.StandardFee}}</td>
                    <td>{{item.DiscountFee}}</td>
                    <td>{{item.BillingValue}}</td>
                    <td>{{item.BillingFormulaString}}</td>
                    <td>{{item.BillingFormulaNote}}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="添加包裹信息" :visible.sync="multiplevisible" :modal-append-to-body="false" center width="400px">
      <el-form label-width="100px" class="etms-dialog-form">
        <el-form-item label="箱号：">
          <el-input size="mini" placeholder="请输入包裹箱号" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="子单号：">
          <el-input size="mini" placeholder="请输入子单号" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="入库重量：">
          <el-input size="mini" type="number" placeholder="请录入重量" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="入库体积：">
          <el-input size="mini" type="number" placeholder="长" class="el-width-70"></el-input>
          <el-input size="mini" type="number" placeholder="宽" class="el-width-70"></el-input>
          <el-input size="mini" type="number" placeholder="高" class="el-width-70"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogMultipleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      inboundactive: 'container',
      inboundlist: [
        {
          WaybillId: '',
          OptimisticLock: '',
          OldOptimisticLock: '',
          CustomerId: '',
          CustomerName: '广州凯捷物流',
          ChannelName: '广州小包',
          LineName: '1区',
          ShipmentRegionName: '中国',
          PurposeRegionName: '美国',
          Odd: '12345678',
          InboundBatch: '20181204ETS001',
          BagCode: '01',
          ConfirmTotalWeight: '1.50',
          ConfirmLong: '10',
          ConfirmWide: '20',
          ConfirmHigh: '7',
          PutStorageTotalWeight: '1.52',
          PutStorageLong: '11',
          PutStorageWide: '22',
          PutStorageHigh: '6',
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ],
      multipleform: {
        isshow: false,
        batch: '20181204ETS001',
        odd: 'RD2156984521CN',
        waybillid: '',
        CustomerName: '广州腾汇',
        ChannelName: '香港DHL',
        LineName: '1区',
        ShipmentRegionName: '中国',
        PurposeRegionName: '俄罗斯',
        parcellist: [
          {
            CaseNumber: '1',
            ParcelCode: '001',
            ParcelBarcode: '',
            ParcleOdd: 'RD2156984521CN-1',
            ParcelConfirmLong: 0,
            ParcelConfirmWide: 0,
            ParcelConfirmHigh: 0,
            ParcelConfirmWeight: 0,
            ParcelConfirmVolumeWeight: 0,
            ParcelPutStorageLong: '',
            ParcelPutStorageWide: '',
            ParcelPutStorageHigh: '',
            ParcelPutStorageWeight: '11',
            ParcelPutStorageVolumeWeight: ''
          }
        ]
      },
      multiplevisible: false,
      multiplelist: [
        {
          WaybillId: '',
          OptimisticLock: '',
          OldOptimisticLock: '',
          CustomerId: '',
          CustomerName: '广州凯捷物流',
          ChannelName: '广州小包',
          LineName: '1区',
          ShipmentRegionName: '中国',
          PurposeRegionName: '美国',
          Odd: '12345678',
          InboundBatch: '20181204ETS001',
          BagCode: '01',
          ConfirmTotalWeight: '1.50',
          ConfirmTotalVolume: '7',
          PutStorageTotalWeight: '1.52',
          PutStorageTotalVolume: '6',
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ],
      containerform: {
        batch: '',
        weight: '',
        quantity: '',
        odd: ''
      },
      containerlist: [
        {
          WaybillId: '',
          OptimisticLock: '',
          OldOptimisticLock: '',
          CustomerId: '',
          CustomerName: '广州凯捷物流',
          ChannelName: '广州小包',
          LineName: '1区',
          ShipmentRegionName: '中国',
          PurposeRegionName: '美国',
          Odd: '12345678',
          InboundBatch: '20181204ETS001',
          ConfirmTotalWeight: '1.50',
          ConfirmQuantity: 1,
          PutStorageTotalWeight: '1.52',
          PutStorageQuantity: 1,
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleClick () {

    },
    submitMultiple () {
      this.multipleform.isshow = true
    },
    deleteMultiple (index, row) { },
    insertMultiple () {
      this.multiplevisible = true
    },
    submitMultipleInbound () {
      this.multipleform.isshow = false
    },
    dialogMultipleSave () { },
    submitContainer () { }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.waybill-fee-table {
  border: 0px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.waybill-fee-table th,
.waybill-fee-table td {
  padding-left: 20px;
  line-height: 20px;
}

.el-table__expanded-cell[class*="cell"] {
  padding: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/inbound_processing.vue